import Constants from "../../../../constants";

const subtitleContainer =
{
    display: "flex",
    alignItems: "baseline",
    justifyContent: "start",
    gap: 10,
    flexFlow: "wrap"
}

const subtitle =
{
    font: Constants.Styles.text.fonts.robotoNormal12,
    color: Constants.Styles.text.colors.gray,
    opacity: 1,
    marginLeft: "10px",
    paddingTop: "7px",
    borderBottom: "2px solid var(--wa-plata)",
    paddingBottom: "10px"
}

const smallGrayText =
{
    font: Constants.Styles.text.fonts.robotoNormal12,
    color: Constants.Styles.text.colors.grayOpacity,
    opacity: 1,
    marginBottom: "5px",
    paddingTop: "7px"
}

const boldText =
{
    fontWeight: "bold",
    marginBottom: 0,
    flexGrow: 1,
    padding: "0px"
}

const btnCloseModal =
{
    top: 15,
    right: 15,
    borderRadius: "100%",
    width: 20,
    height: 20,
    border: "1px solid " + Constants.Styles.background.redButtonClose,
    color: Constants.Styles.text.colors.redButtonClose,
    background: Constants.Styles.background.transparent
}

const cellStyle = {
    borderBottom: "1px solid var(--wa-gris)",
    textAlign: "right",
    width: "1px",
    verticalAlign: "bottom",
    padding: "unset",
    paddingBottom: "10px"    
}

const errorMessage =
{
    color: Constants.Styles.text.colors.red,
    width: "100%",
    font: Constants.Styles.text.fonts.robotoNormal16,
    padding: "5px"
}

export const styles = {
    subtitleContainer,
    subtitle,
    smallGrayText,
    boldText,
    btnCloseModal,
    cellStyle,
    errorMessage
}